



















































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import {
  phoneSelect,
  emailSelect,
  languageSelect,
  recommenderSelect,
  languageLevelSelect,
  educationSelect,
  graduatedSelect,
  applicantSelect,
} from '~/utils/selectItem'
import moment from 'moment'
import { phoneFormat } from '~/utils/phoneFormat'

@Component({
  layout: 'auth',
  head: {
    script: [
      { src: '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js' },
    ],
  },
})
export default class Support extends Vue {
  moment = moment
  isOpenModal = false
  isOpen = false
  navMenu = ['인재채용']
  applicantSelect = applicantSelect
  graduatedSelect = graduatedSelect
  educationSelect = educationSelect
  emailSelect = emailSelect
  phoneSelect = phoneSelect
  languageSelect = languageSelect
  recommenderSelect = recommenderSelect
  languageLevelSelect = languageLevelSelect
  isChecked: boolean = false
  isDisabled = false
  dateFormat = 'YYYYMMDD'
  timeFormat = 'HH:mm'
  privacyData =
    '<style>table.tc1 { border-collapse: collapse; width: 100%; margin: 0 0 10px 0; text-align: center; border:1px solid gray} table th, tr td{    border:1px solid gray;} thead{ background: #E5E7EB;}</style><div class="persona-info"> <h3 class="tbg5">개인정보 수집 및 이용 동의</h3><p>    &lt;이월드&gt;(이하 "회사"라고 함)은 개인정보보호법 및 정보통신망 이용 촉진 및 정보보호 등에 관한 법률<br>    에 따라 정보주체의 개인정보를 수집 및 이용하기 위하여 다음 사항을 알리고 정보주체의 동의를 받습니다.</p>	<h3 class="tbg5">1. 개인정보의 수집 · 이용목적</h3><div>    회사는 개인정보를 다음의 목적을 위해 처리합니다. 처리한 개인정보는 다음의 목적이외의 용도로는 사용하지 않으며    이용 목적이 변경될 시에는 사전동의를 구하겠습니다.    <p>1) 입사지원 및 선발전형</p>    <p>2) 지원자의 신원 확인, 요청/문의사항 확인, 사실조사를 위한 연락/통지, 처리결과 통보</p></div>	<h3 class="tbg5">2. 수집하는 개인정보</h3><p>1) 회사는 다음의 개인정보를 처리하고 있습니다.</p>	<table class="tc1">			<colgroup><col width="10%"><col width="15%"><col width="20%"><col width="30%"><col width="25%"></colgroup>    <thead>        <tr>        <th>분류</th>        <th>수집시점</th>        <th>수집 및 이용목적</th>        <th>수집항목</th>        <th>이용 및 보유기간</th>        </tr>    </thead>    <tbody>        <tr>        <th>필수</th>        <td>아르바이트 지원</td>        <td>아르바이트 지원서 제출</td>        <td>사진, 이름, 성별, 핸드폰번호, 주소, 학력사항(학교명,전공명,학력,졸업여부,입학년월,졸업년월), 희망직종(1지망~3지망), 희망조건(근무기간, 근무시간, 근무일)</td><td>입사지원부터 3년간 보관 후 자동 파기<br>※ 단, 불합격시, 5일 보관 후 자동 파기</td>        </tr>        <tr>        <th>선택</th>        <td>아르바이트 지원</td>        <td>아르바이트 지원서 제출</td>        <td>이메일, 병역구분, 복무기간, 흡연여부, 전화번호, 경력사항, 자격사항,외국어사항, 면접일자,기타사항(추천인,지원경로,지원동기,이월드경력)</td>        <td>입사지원부터 3년간 보관 후 자동 파기<br>※ 단, 불합격시, 5일 보관 후 자동 파기</td>        </tr>    </tbody></table><p>2) 관련법령</p>			<table class="tc1">    <thead>        <tr>        <th>근거법령</th>        <th>보유정보</th>        <th>보유기간</th>        </tr>    </thead>    <tbody>        <tr>        <th rowspan="2">전자상거래 등에서의 소비자보호에 관한 법률</th>        <td>계약 또는 청약철회 등에 관한 기록</td>        <td>5년</td>        </tr>        <tr>        <td>소비자의 불만 또는 분쟁처리에 관한 기록</td>        <td>3년</td>        </tr>        <tr>        <th>통신비밀보호법</th>        <td>로그인 기록</td>        <td>3개월</td>        </tr>    </tbody></table><p>3) 회사는 다음과 같은 방법으로 개인정보를 수집합니다.<br>- 온라인: 채용사이트(로그인정보 입력)</p>	<h3 class="tbg5">3. 개인정보의 처리 및 보유 기간</h3><p>    - 회사는 정보주체로부터 개인정보 수집·이용 동의일로부터 채용 프로세스가 종료될 때까지 개인정보를 보유·처리합니다.</p>	<p style="font-weight:600; color:#222;"> ※귀하께서는 귀하의 개인정보 수집·이용에 대한 동의를 거부하실 권리가 있습니다.<br>단, 동의를 거부하실 경우 서류전형 지원이 불가합니다.</p><h3 class="tbg6">개인정보 수집 및 이용에 동의하십니까?</h3></div>'
  tmpData: any = {
    phone: null,
    phoneNumber: null,
    bcode: null,
    address: null,
    addressDetail: null,
  }

  email: any = {
    id: '',
    url: '',
    host: '',
  }

  data: any = {
    image: '',
    name: '',
    email: '',
    birthday: '',
    desiredStartDate: '',
    desiredEndDate: '',
    sex: '',
    phone: '',
    address: '',
    militaryServiceStatus: '면제',
    militaryServiceStartDate: null,
    militaryServiceEndDate: null,
    experienceStartDate: null,
    experienceEndDate: null,
    educationStartDate: null,
    educationEndDate: null,
    desiredStartTime: null,
    desiredEndTime: null,
  }

  certificate = [{ name: '', grade: '' }]
  language = [{ name: '', grade: '' }]
  career = [{}]

  essentialArrayKey: any = ['career']
  desiredCheck = false
  desiredDay = ''
  essentialDesiredCheck = false

  complete() {
    this.isOpen = false
    this.$router.push('/home/recruit/result')
  }

  get image() {
    return this.data.image
  }

  get essentialCheck() {
    const essentialKey = [
      'image',
      'name',
      'birthday',
      'sex',
      'schoolName',
      'major',
      'education',
      'educationStatus',
      'first',
      'second',
      'third',
      'desiredStartDate',
      'desiredEndDate',
    ]

    const tmpKey = ['phone', 'phoneNumber', 'bcode', 'address', 'addressDetail']

    let tmp = []
    tmp.push(essentialKey.every((a: any) => this.data[a]))
    tmp.push(tmpKey.every((a: any) => this.tmpData[a]))

    return (
      tmp.every((b: any) => b) && this.isChecked && this.essentialDesiredCheck
    )
  }

  changeEmailHost(item: any) {
    this.email.url = emailSelect.find((e) => e.key == item)?.key ?? ''
  }

  change(key: any, value: any) {
    this.data[key] = value.target.value
    const { militaryServiceStatus, smoking, sex } = this.data

    if (!militaryServiceStatus || !smoking || !sex) {
      return ''
    }
  }

  cancle() {
    if (confirm('취소하시겠습니까? 입력된 정보는 삭제됩니다.')) {
      this.$router.push('/')
    } else {
      return
    }
  }

  handleChange(value: any) {
    this.data.birthday = moment(value).format('YYYY-MM-DD')
  }

  changeDays(value: any) {
    this.essentialDesiredCheck = true

    if (value.target.value !== '상시') {
      this.data.desiredDay = value.target.value
      this.desiredCheck = false
    } else {
      this.desiredCheck = true
    }
  }

  uploadImage(value: any) {
    this.data.image = value
  }

  update(value: any) {
    this.isChecked = value
  }

  oncomplete(data: any) {
    let fullAddress = ''
    let extraAddress = ''

    if (data.userSelectedType === 'R') {
      fullAddress = data.roadAddress
      if (data.buildingName !== '') {
        extraAddress = data.buildingName
      }
    } else if (data.userSelectedType === 'J') {
      fullAddress = data.jibunAddress
    } else {
      fullAddress = data.address
    }
    fullAddress += extraAddress !== '' ? ` (${extraAddress})` : ''

    this.tmpData.bcode = data.zonecode
    this.tmpData.address = fullAddress
    this.isOpenModal = false
  }

  deleteItem(i: any, type: any) {
    switch (type) {
      case 'career':
        this.career.splice(i, 1)
        break
      case 'certificate':
        this.certificate.splice(i, 1)
        break

      case 'language':
        this.language.splice(i, 1)
        break
    }
  }

  addItem(type: any) {
    switch (type) {
      case 'career':
        this.career.push({
          workplace: '',
          workStartDate: '',
          workEndDate: '',
          job: '',
          jobPosition: '',
          reason: '',
        })
        break
      case 'certificate':
        this.certificate.push({ name: '', grade: '' })
        break
      case 'language':
        this.language.push({ name: '', grade: '' })
        break
    }
  }

  async submit() {
    if (!this.data.image) {
      this.$message.warn('사진을 등록해주세요.')
      return
    }

    if (!this.data.name) {
      this.$message.warn('이름을 입력해주세요.')
      return
    }

    if (!this.tmpData.phone || !this.tmpData.phoneNumber) {
      this.$message.warn('휴대폰 번호를 입력해주세요.')
      return
    }

    if (!this.data.birthday.toString()) {
      this.$message.warn('생년월일을 입력해주세요.')
      return
    }

    if (!this.data.sex) {
      this.$message.warn('성별을 입력해주세요.')
      return
    }

    if (
      !this.tmpData.bcode ||
      !this.tmpData.address ||
      !this.tmpData.addressDetail
    ) {
      this.$message.warn('주소를 입력해주세요.')
      return
    }

    if (!this.data.first) {
      this.$message.warn('희망조건 중 1지망을 입력해주세요.')
      return
    }

    if (!this.data.second) {
      this.$message.warn('희망조건 중 2지망을 입력해주세요.')
      return
    }

    if (!this.data.third) {
      this.$message.warn('희망조건 중 3지망을 입력해주세요.')
      return
    }

    if (
      !this.data.desiredStartDate.toString() ||
      !this.data.desiredEndDate.toString()
    ) {
      this.$message.warn('희망 근무기간을 입력해주세요.')
      return
    }

    if (!this.desiredCheck && !this.data.desiredDay) {
      this.$message.warn('희망 근무일을 입력해주세요.')
      return
    }

    if (!this.data.schoolName) {
      this.$message.warn('학교명을 입력해주세요.')
      return
    }

    if (!this.data.major) {
      this.$message.warn('전공명을 입력해주세요.')
      return
    }

    if (!this.data.education) {
      this.$message.warn('학력을 입력해주세요.')
      return
    }

    if (!this.data.educationStatus) {
      this.$message.warn('졸업구분을 입력해주세요.')
      return
    }

    if (this.desiredCheck) {
      this.data.desiredDay = this.desiredDay
    }

    this.data.birthday = moment(this.data.birthday).format('YYYY-MM-DD')
    this.data.career = this.career
    this.data.certificate = this.certificate
    this.data.language = this.language
    const { id, url } = this.email
    this.data.email = `${id}@${url}`

    this.data.militaryServiceStatus =
      this.data.militaryServiceStatus === null
        ? 2
        : this.data.militaryServiceStatus

    this.data.career = Object.values(this.career[0]).every(
      (a: any) => a === null || a === ''
    )
      ? []
      : this.career
    this.data.certificate = Object.values(this.certificate[0]).every(
      (a: any) => a === null || a === ''
    )
      ? []
      : this.certificate
    this.data.language = Object.values(this.language[0]).every(
      (a: any) => a === null || a === ''
    )
      ? []
      : this.language

    this.data.address =
      this.tmpData.bcode + this.tmpData.address + this.tmpData.addressDetail

    this.data.phone = phoneFormat(this.tmpData.phone + this.tmpData.phoneNumber)

    if (this.essentialCheck) {
      try {
        await this.$axios.$post(`/api/v1/user/applicant`, this.data)
        this.isOpen = true
      } catch {
        this.$message.warn('아르바이트 지원서 작성에 실패하였습니다.')
      }
    }
  }
}
